import { Component, OnDestroy } from '@angular/core';

import { ReplaySubject } from 'rxjs';

import { SharedLanguageService } from '@language';
import {
    ExtendedProfileField,
    FieldReadHelper,
    PartialRecord,
    ShComplexReadonlyFieldComponent,
    ShSearchRoutingService
} from '@stylehaven/components';
import { ApiFragment } from '../../../../record/entities/api-fragment.entity';
import { Metadata } from '../../../../record/entities/metadata.entity';
import { GetProfileChildFieldLabels } from '../../../helpers/get-profile-field-label.helper';

@Component({
    standalone: false,
    selector: 'digihaven-document-publicity-readonly-field',
    templateUrl: './document-publicity-readonly-field.component.html',
    styleUrls: ['../../base-generic-readonly-field/base-generic-readonly-field.component.scss']
})
export class DocumentPublicityReadonlyFieldComponent extends ShComplexReadonlyFieldComponent implements OnDestroy {
    private readonly MOTIVATION_TRIGGER_VALUE: string = 'in principe openbaar';

    public labels!: Map<string, string>;

    public apiFragment$: ReplaySubject<ApiFragment> = new ReplaySubject<ApiFragment>(1);

    constructor(
        protected fieldHelper: FieldReadHelper,
        protected shSearchRoutingService: ShSearchRoutingService,
        protected translateService: SharedLanguageService
    ) {
        super(fieldHelper, shSearchRoutingService);
    }

    init(profileField: ExtendedProfileField, record: PartialRecord): void {
        this.labels = GetProfileChildFieldLabels(this.translateService, profileField);
        const apiFragment = new ApiFragment(record.metadata as any as Metadata);
        this.apiFragment$.next(apiFragment);
    }

    shouldShowMotivation(record: ApiFragment): boolean {
        const selectedValue: string = record.metadata.Dynamic.DocumentPublicity?.Regimen ?? null;
        return selectedValue ? selectedValue.toLowerCase() === this.MOTIVATION_TRIGGER_VALUE : false;
    }

    public ngOnDestroy(): void {
        this.apiFragment$.complete();
        super.ngOnDestroy();
    }
}
